import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
@Injectable({
  providedIn: 'root'
})
export class VersionService {

  constructor(private apiService: ApiService) { }
  insertar(data: any) {
      this.apiService.setUrlPathApi('version/');
      return this.apiService.executePostJson(data).pipe();
  }
  actualizar(data: any) {
    this.apiService.setUrlPathApi('version/');
    return this.apiService.executePutJson(data).pipe();
  }
  eliminar(id: any) {
    this.apiService.setUrlPathApi('version/');
    return this.apiService.executeDeleteJson(`${id}`);
  }
    obtener(id: any) {
      this.apiService.setUrlPathApi(`version/${id}`);
      return this.apiService.execGetJson();
  }
    buscar(desc:any) {
      this.apiService.setUrlPathApi('version/');
      return this.apiService.execGetQueryJson(`buscar?desc=${desc}`)
    }
    obtenerImagen(id:any){
      this.apiService.setUrlPathApi(`version/public/img/${id}`)
      return this.apiService.execGetJson();
    }
    notificar(){
      this.apiService.setUrlPathApi('version/notificar')
      return this.apiService.execGetJson()
    }
       /* Obtener eecc clientes */
       obtenerEstadoCuentaClientes(codcli:string,solopendientes:boolean,incdocdes:boolean,ubica:string){
        this.apiService.setUrlPathApi(`cliente/${codcli}/eecc-master`);
        return this.apiService.execGetQueryJson(`?solopendientes=${solopendientes}&incdocdes=${incdocdes}&ubica=${ubica}`);
      }
      /* Imprimir factura */
       pdfFormatoDefaultAdmin(numint:number,agrupado:boolean){
        this.apiService.setUrlPathApiReport(`factura/${numint}/report-master/format-default.pdf`);
        return this.apiService.execGetQueryJsonPDF(`?agrupado=${agrupado}`).pipe();
       }
       obtenerGlosaMaster(item:number){
        this.apiService.setUrlPathApi(`company/glosa-master/${item}`);
        return this.apiService.execGetJson();
       }
}
